import React from 'react';
import EntityListFetcher from '../components/EntityListFetcher';
import typeIntro from '../static/introspection/Company360.json';
import { ENTITY } from '../utils/entities';
import { Company360ListQuery } from 'graphql/query/Company360ListQuery';
import Company360Filters from '../static/introspection/Company360FilterInput.json';

const Company360List = () => (
	<EntityListFetcher
		query={Company360ListQuery}
		entityName={ENTITY.COMPANY_360}
		headers={['companyLevel', 'status']}
		sortables={['companyLevel', 'status']}
		customFields={[
			{
				header: 'reference',
				field: function (entity) {
					if (entity.Company) {
						return {
							name: 'reference',
							label: 'reference',
							type: 'Entity',
							mapTo: ENTITY.COMPANY,
							value: entity.Company,
						};
					} else if (entity.FoodService) {
						return {
							name: 'reference',
							label: 'reference',
							type: 'Entity',
							mapTo: ENTITY.FOOD_SERVICE,
							value: entity.FoodService,
						};
					} else if (entity.Retailer) {
						return {
							name: 'reference',
							label: 'reference',
							type: 'Entity',
							mapTo: ENTITY.RETAILER,
							value: entity.Retailer,
						};
					} else if (entity.Service) {
						return {
							name: 'reference',
							label: 'reference',
							type: 'Entity',
							mapTo: ENTITY.SERVICE,
							value: entity.Service,
						};
					} else if (entity.Brand) {
						return {
							name: 'reference',
							label: 'reference',
							type: 'Entity',
							mapTo: ENTITY.BRAND,
							value: entity.Brand,
						};
					} else {
						return {
							name: 'reference',
							label: 'reference',
							type: 'String',
							value: '',
						};
					}
				},
			},
		]}
		typeIntro={typeIntro}
		filtersIntro={Company360Filters}
		filterFields={[
			'Company',
			'FoodService',
			'Retailer',
			'Service',
			'Brand',
			'statuses',
		]}
	/>
);

export { Company360List };